import type { JSX } from 'react'
import type { ITVShowDescriptionProps } from 'blocks/Description/Templates'
import type { ITextBlockDescriptionType3 } from 'blocks/TextBlock/Templates'
import type { IPopupProps } from '../Popup'

import { TextBoxColors } from 'atoms/TextBox'
import { TVShowDescription } from 'blocks/Description/Templates'
import { TextBlockDescriptionType3 } from 'blocks/TextBlock/Templates'
import { Popup } from '../Popup'
import { PopupColumnGap, PopupPaddings, PopupRowGap } from '../Popup.h'
import { TVShowPopupSC } from '../Popup.styled'

export interface ITVShowPopupProps extends Omit<IPopupProps, 'children'> {
  title?: ITVShowDescriptionProps['title']
  description?: ITVShowDescriptionProps['description']
  labels?: ITVShowDescriptionProps['list']
  textDescription?: string
  directors?: string
  stars?: string
  onClick?: () => void
  onClose?: () => void
  list?: {
    title?: ITextBlockDescriptionType3['title']
    description?: ITextBlockDescriptionType3['description']
  }[]
}

export const TVShowPopup = ({
  title = '',
  description = '',
  textDescription,
  directors,
  stars,
  labels = [],
  list = [],
  width = '33rem',
  padding = PopupPaddings.SIZE_40,
  rowGap = PopupRowGap.INDENT_60,
  columnGap = PopupColumnGap.INDENT_20,
  onClick,
  onClose,
  ...rest
}: ITVShowPopupProps): JSX.Element => (
  <TVShowPopupSC width={width} onClick={onClick}>
    <Popup
      width={width}
      rowGap={rowGap}
      columnGap={columnGap}
      padding={padding}
      onClose={onClose}
      {...rest}
    >
      <TVShowDescription
        title={title}
        description={description}
        list={labels}
      />
      <>
        {textDescription && (
          <TextBlockDescriptionType3
            title={'Description: '}
            description={textDescription}
            colorDescription={TextBoxColors.TEXT_ICON_PRIMARY}
          />
        )}
        {directors && (
          <TextBlockDescriptionType3
            title={'Directors: '}
            description={directors}
            colorDescription={TextBoxColors.TEXT_ICON_PRIMARY}
          />
        )}
        {stars && (
          <TextBlockDescriptionType3
            title={'Stars: '}
            description={stars}
            colorDescription={TextBoxColors.TEXT_ICON_PRIMARY}
          />
        )}
        {list?.length > 0 &&
          list.map(({ title = '', description = '' }, index) => (
            <TextBlockDescriptionType3
              key={`${index}${title}`}
              title={title}
              description={description}
              colorDescription={TextBoxColors.TEXT_ICON_PRIMARY}
            />
          ))}
      </>
    </Popup>
  </TVShowPopupSC>
)
